import type { RecentItem } from '../../../components/dashboard/recent-items';
import type { PersistMigrationDefinition } from '../persist-migration';

type PersistedRecentItemsState = {
  itemsByScope: Record<string, RecentItem[]>;
};

export const recentItemsMigration: PersistMigrationDefinition<PersistedRecentItemsState> =
  {
    version: 0,
    fallback: () => ({ itemsByScope: {} }),
    steps: [],
  };
